export enum OperationsChartCategory {
  PUNCTUALITY = 'PUNCTUALITY',
  REJECTIONS = 'REJECTIONS',
  PREPARATION_TIME = 'PREPARATION_TIME',
}
